import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../view/Home/Home";
import Header from "../Component/Header/Header";
import Footer from "../Component/Footer/Footer";
import News from "../view/News/News";
import PQRS from "../view/Pqrs/Pqrs";
import Linkage from "../view/Linkage/Linkage";
import Update from "../view/Update/Update";
import Disengagement from "../view/Disengagement/Disengagement";
import Legal from "../view/Legal/Legal";
import Contact from "../view/Contact/Contact";
import AbountUs from "../view/Abountus/Abountus";
import Login from "../view/Login/Login";
import { LoginContextProvider } from '../Component/Context/LoginContext';  // Ajusta la ruta según tu estructura

function Router() {
    return (
        <LoginContextProvider>
            <BrowserRouter>
                <Header />
                <Routes>
                    <Route exact index element={<Home />} />
                    <Route exact path="/Inicio" element={<Home />} />
                    <Route exact path="/Comunicaciones" element={<News />} />
                    <Route exact path="/PQRS" element={<PQRS />} />
                    <Route exact path="/Vinculacion" element={<Linkage />} />
                    <Route exact path="/Actualizar" element={<Update />} />
                    <Route exact path="/Desvincular" element={<Disengagement />} />
                    <Route exact path="/Agendar" element={<Legal />} />
                    <Route exact path="/Contactanos" element={<Contact />} />
                    <Route exact path="/Quienes_Somos" element={<AbountUs />} />
                    <Route exact path="/Inicio_de_sesion" element={<Login />} />
                </Routes>
                <Footer />
            </BrowserRouter>
        </LoginContextProvider>
    );
}

export default Router;
